import { isUrlValid } from '@project-gd-x/shared-web/src/helpers/validation/validation';
import { NavigationGuard } from 'vue-router';

import { hideModalSpinner, showModalSpinner } from '@/components/modal/helpers/modal/modal';
import { navigate } from '@/helpers/navigator/navigator';
import { trackCameBack } from '@/helpers/track-came-back/track-came-back';
import { dispatch } from '@/store/store-helper';

export const autologinBeforeEnter: NavigationGuard = async (to) => {
  const autologinHash = to.params.autologinHash as string;
  const rawRedirectUrl = (to.params.redirectUrl as string) ?? '';

  showModalSpinner();

  try {
    const url = decodeURIComponent(rawRedirectUrl);
    const isRedirectValid = url !== '' && isUrlValid(url);

    await dispatch('actionSignin', {
      type: 'autologin',
      hash: autologinHash,
      landingUrl: isRedirectValid ? url : window.location.href,
    });

    if (isRedirectValid) {
      // We need to re-track user's landing-url if he has been redirected from an autologin.
      trackCameBack(url);
      navigate(url);
      return false;
    }

    trackCameBack();
    return { name: 'search' };
  } catch {
    return { name: 'signin' };
  } finally {
    hideModalSpinner();
  }
};
